import script from "./SignatureRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./SignatureRow.vue?vue&type=script&lang=ts&setup=true"

import "./SignatureRow.vue?vue&type=style&index=0&id=69ff2316&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69ff2316"]])

export default __exports__